import { useMutation } from '@tanstack/react-query'
import { logSentryError } from '@node-space/utils'
import { postNotifciationDestinations } from 'services/WebHooksService'

export const useCreateNotificationDestinationsMutation = () => {
  return useMutation({
    mutationFn: postNotifciationDestinations,
    onError(error: { status: number; message?: string; errorList?: unknown }, data) {
      logSentryError('Error from useCreateWebhookDestinationsMutation', error, data)
    },
  })
}
